export interface Deferred<T = any> {
    promise: Promise<T>;
    resolve: (value: T) => void;
    reject: (reason?: any) => void;
    resolved: boolean;
    rejected: boolean;
    completed: boolean;
}

export function create<T = any>() {
    /**
     * reference: https://github.com/moll/js-promise-defer/blob/master/index.js
     */
    const deferred: Deferred<T> = Object.create({});
    deferred.promise = new Promise<T>(function(resolve, reject) {
        deferred.resolve = (...rest) => {
            deferred.resolved = true;
            deferred.completed = true;
            resolve(...rest);
        };
        deferred.reject = (...rest) => {
            deferred.rejected = true;
            deferred.completed = true;
            reject(...rest);
        };
    });
    return deferred;
}
